export const addonModel = {
  item: "",
  quantity: 0,
  price: 0
};
